export default __webpack_public_path__ + "static/media/longchamp29.883f0ebe.jpg";